<template>
  <b-modal class="modal-x" :visible="visible" @hide="onClose" :title="modalTitle" size="lg" no-backdrop no-close-on-backdrop>
    <b-row>
        <b-col>
            <b-form-group label="ប្រភេទប្រូម៉ូសិន" :class="{ 'form-group-error': $v.form.RuleType.$error }">
              <b-form-select v-model="form.RuleType" :options="ruleOptions" />
            </b-form-group>
        </b-col>
      <b-col>
        <b-form-group label="ចាប់ពីថ្ងៃ" :class="{ 'form-group-error': $v.form.StartDate.$error }">
          <b-form-input v-model="form.StartDate" type="date" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="ផុតកំណត់ថ្ងៃ" :class="{ 'form-group-error': $v.form.EndDate.$error }">
          <b-form-input v-model="form.EndDate" type="date" />
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <div v-if="Number(form.RuleType) === 1">
      <table class="grid">
        <thead>
          <tr>
            <th>ចាប់ពីចំនួន</th>
            <th>ដល់ចំនួន</th>
            <th>តម្លៃលក់</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(line, i) in form.JsonObject" :key="i">
            <td><div :class="{ 'form-group-error': $v.form.JsonObject.$each[i].MinQty.$error }"><b-form-input v-model="line.MinQty" type="number"/></div></td>
            <td><div :class="{ 'form-group-error': $v.form.JsonObject.$each[i].MaxQty.$error }"><b-form-input v-model="line.MaxQty" type="number"/></div></td>
            <td><div :class="{ 'form-group-error': $v.form.JsonObject.$each[i].Price.$error }"><b-form-input v-model="line.Price" type="number"/></div></td>
            <td><b-button variant="danger" @click="removeLine(i)">X</b-button></td>
          </tr>
        </tbody>
      </table>
      <div class="mt-3">
        <b-button variant="primary" @click="addLine">+ បន្ថែមលក្ខខ័ណ្ឌ</b-button>
      </div>
    </div>

    <div v-else-if="Number(form.RuleType) === 2">
      <table class="grid">
        <thead>
          <tr>
            <th>ចំនួន</th>
            <th>ថែមមុខទំនិញ</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(line, i) in form.JsonObject" :key="i">
            <td><div :class="{ 'form-group-error': $v.form.JsonObject.$each[i].MinQty.$error }"><b-form-input v-model="line.MinQty" type="number"/></div></td>
            <td><div :class="{ 'form-group-error': $v.form.JsonObject.$each[i].ItemName.$error }"><AuthCompleted :value="line.ItemName" size="" @select="selectPromotionItem($event, line)"/></div></td>
            <td><b-button variant="danger" @click="removeLine(i)">X</b-button></td>
          </tr>
        </tbody>
      </table>
      <div class="mt-3">
        <b-button variant="primary" @click="addLine">+ បន្ថែមលក្ខខ័ណ្ឌ</b-button>
      </div>
    </div>

    <div v-else-if="Number(form.RuleType) === 3">
      <table class="grid">
        <thead>
          <tr>
            <th>ទិញផ្គួបជាមួយមុខទំនិញ</th>
            <th>តម្លៃលក់</th>       
          </tr>
        </thead>
        <tbody>
          <tr v-for="(line, i) in form.JsonObject" :key="i">
            <td><div :class="{ 'form-group-error': $v.form.JsonObject.$each[i].ItemName.$error }"><AuthCompleted :value="line.ItemName" size="" @select="selectPromotionItem($event, line)"/></div></td>
            <td><div :class="{ 'form-group-error': $v.form.JsonObject.$each[i].Price.$error }"><b-form-input v-model="line.Price" type="number"/></div></td>    
            <td><b-button variant="danger" @click="removeLine(i)">X</b-button></td>
          </tr>
        </tbody>
      </table>
      <div class="mt-3">
        <b-button variant="primary" @click="addLine">+ បន្ថែមលក្ខខ័ណ្ឌ</b-button>
      </div>
    </div>

    <template #modal-footer>
      <b-button variant="danger" @click="onClose">បោះបង់</b-button>
      <b-button variant="success" @click="onSubmit">{{ form.Id ? 'កែប្រែ' : 'រក្សាទុក' }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import { helpers, required, minValue, numeric, decimal } from 'vuelidate/lib/validators';
import AuthCompleted from '../AutoCompleted2.vue';
const minLessThanMax = helpers.withParams(
  { type: 'minLessThanMax' },
  function (value, vm) {
    if (value == null || vm.MinQty == null) return true
    return Number(value) > Number(vm.MinQty)
  }
)
export default {
  components: {
    AuthCompleted
  },
  props: {
    visible: Boolean,
    value: Object
  },
  data() {
    return {
      form: this.initForm(),
      isApplyingValue: false,
      ruleOptions: [
        { value: 1, text: 'បញ្ជុះតម្លៃ' },
        { value: 2, text: 'ទិញថែម' },
        { value: 3, text: 'ទិញផ្គួប' }
      ]
    }
  },
  validations() {
    const ruleType = Number(this.form.RuleType)
    let jsonValidation = {}

    if (ruleType === 1) {
      jsonValidation = {
        MinQty: { required, numeric, minValue: minValue(1) },
        MaxQty: { required, numeric, minLessThanMax },
        Price: { required, decimal }
      }
    }else if (ruleType === 2) {
      jsonValidation = {
        MinQty: { required, numeric, minValue: minValue(1) },
        ItemName: { required }
      }
    }else if (ruleType === 3) {
      jsonValidation = {
        ItemName: { required },
        Price: { required, decimal }
      }
    }

    return {
      form: {
        RuleType: { required },
        StartDate: { required },
        EndDate: { required },
        JsonObject: {
          required,
          $each: jsonValidation
        }
      }
    }
  },
  computed: {
    modalTitle() {
      return this.form && this.form.Id ? 'កែប្រែប្រូម៉ូសិន' : 'បង្កើតប្រូម៉ូសិន'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.isApplyingValue = true
        this.form = val ? JSON.parse(JSON.stringify(val)) : this.initForm()
        this.$nextTick(() => {
          this.isApplyingValue = false
        })
      }
    },
    'form.RuleType'(ruleType) {
      if (this.isApplyingValue) return
      this.form.JsonObject = [this.createLine(ruleType)]
    }
  },
  methods: {
    initForm() {
      const today = this.today()
      return {
        Id: '',
        ItemId: '',
        RuleType: 1,
        StartDate: today,
        EndDate: today,
        JsonObject: [this.createLine(1)]
      }
    },
    today() {
      return new Date().toISOString().slice(0, 10)
    },
    createLine(ruleType) {
      if (Number(ruleType) === 1) return { MinQty: 1, MaxQty: 2, Price: 0 }
      if (Number(ruleType) === 2) return { MinQty: 1, ItemId: '', ItemName: '' }
      if (Number(ruleType) === 3) return { ItemId: '', ItemName: '', Price: 0 }
      return {}
    },
    addLine() {
      this.form.JsonObject.push(this.createLine(this.form.RuleType))
    },
    removeLine(i) {
      this.form.JsonObject.splice(i, 1)
    },
    selectPromotionItem(item, line) {
      line.ItemId = item.Id
      line.ItemName = item.Name
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.$emit('save', JSON.parse(JSON.stringify(this.form)))
      this.$emit('update:visible', false)
    },
    onClose() {
      this.$emit('update:visible', false)
      this.form = this.initForm()
      this.$v.$reset()
    }
  }
}
</script>
